import React, { useState } from 'react';
import { MenuIcon, XIcon, GlobeIcon, UserCircle } from 'lucide-react';
import { Button } from './Button';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  // Function to handle navigation to home page sections from other pages
  const handleSectionLink = (sectionId: string) => (e: React.MouseEvent) => {
    if (location.pathname !== '/') {
      e.preventDefault();
      window.location.href = `/${sectionId}`;
    }
  };
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm" data-id="element-560">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between" data-id="element-561">
        <div className="flex items-center" data-id="element-562">
          <a href="/" className="flex items-center" data-id="element-563">
            <div className="h-10 w-10 rounded-full bg-[#2563EB] flex items-center justify-center mr-2" data-id="element-564">
              <GlobeIcon className="h-6 w-6 text-white" data-id="element-565" />
            </div>
            <span className="text-xl font-bold" data-id="element-566">TravelSIM</span>
          </a>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-567">
          <a href={location.pathname === '/' ? '#plans' : '/#plans'} className="font-medium hover:text-[#2563EB] transition-colors" onClick={handleSectionLink('#plans')} data-id="element-568">
            Plans
          </a>
          <a href={location.pathname === '/' ? '#how-it-works' : '/#how-it-works'} className="font-medium hover:text-[#2563EB] transition-colors" onClick={handleSectionLink('#how-it-works')} data-id="element-569">
            How It Works
          </a>
          <a href={location.pathname === '/' ? '#faq' : '/#faq'} className="font-medium hover:text-[#2563EB] transition-colors" onClick={handleSectionLink('#faq')} data-id="element-570">
            FAQ
          </a>
          <Link to="/help" className="font-medium hover:text-[#2563EB] transition-colors" data-id="element-571">
            Help Center
          </Link>
          <Link to="/blog" className="font-medium hover:text-[#2563EB] transition-colors" data-id="element-572">
            Blog
          </Link>
          <div className="border-l border-gray-200 h-6 mx-2" data-id="element-573"></div>
          <Link to="/dashboard" className="flex items-center text-gray-700 hover:text-[#2563EB] transition-colors" data-id="element-574">
            <UserCircle className="h-5 w-5 mr-2" data-id="element-575" />
            Dashboard
          </Link>
          <Button variant="primary" data-id="element-576">Get Your eSIM</Button>
        </nav>
        {/* Mobile menu button */}
        <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-577">
          {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-578" /> : <MenuIcon className="h-6 w-6" data-id="element-579" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white absolute w-full shadow-lg" data-id="element-580">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-581">
            <a href={location.pathname === '/' ? '#plans' : '/#plans'} className="font-medium py-2 hover:text-[#2563EB] transition-colors" onClick={handleSectionLink('#plans')} data-id="element-582">
              Plans
            </a>
            <a href={location.pathname === '/' ? '#how-it-works' : '/#how-it-works'} className="font-medium py-2 hover:text-[#2563EB] transition-colors" onClick={handleSectionLink('#how-it-works')} data-id="element-583">
              How It Works
            </a>
            <a href={location.pathname === '/' ? '#faq' : '/#faq'} className="font-medium py-2 hover:text-[#2563EB] transition-colors" onClick={handleSectionLink('#faq')} data-id="element-584">
              FAQ
            </a>
            <Link to="/help" className="font-medium py-2 hover:text-[#2563EB] transition-colors" data-id="element-585">
              Help Center
            </Link>
            <Link to="/blog" className="font-medium py-2 hover:text-[#2563EB] transition-colors" data-id="element-586">
              Blog
            </Link>
            <div className="flex items-center space-x-2 py-2" data-id="element-587">
              <GlobeIcon className="h-4 w-4" data-id="element-588" />
              <select className="bg-transparent border-none text-sm font-medium focus:outline-none" data-id="element-589">
                <option value="en" data-id="element-590">EN</option>
                <option value="ar" data-id="element-591">AR</option>
                <option value="fr" data-id="element-592">FR</option>
              </select>
            </div>
            <Link to="/dashboard" className="flex items-center font-medium py-2 hover:text-[#2563EB] transition-colors" data-id="element-593">
              <UserCircle className="h-5 w-5 mr-2" data-id="element-594" />
              Dashboard
            </Link>
            <Button variant="primary" fullWidth data-id="element-595">
              Get Your eSIM
            </Button>
          </div>
        </div>}
    </header>;
}